import { useEffect, useState, useCallback } from 'react';
import { WebApiModelsMemberField, WebApiModelsMembershipProduct, WebApiServicesDataTransferObjectsGroupServiceGroupResultDto } from '../../Repository/eventbookyapi';
import MemberList from '../../Components/Users/MemberList';
import { AuthProvider } from '../../Providers/authProvider';
import { TextService } from '../../Services/TextService';
import LeftMenu from './LeftMenu';
import { MemberService } from '../../Services/MemberService';
import { AuthenticatedUser } from '../../Types/AuthenticatedUser';
import LayoutLeftMenu from '../../Components/Layout/LayoutLeftMenu';
import { IntegrationService } from '../../Services/IntegrationService';
import { IntegrationType } from '../../Types/IntegrationType';
import { MemberFieldService } from '../../Services/MemberFieldService';
import LoadingSpinner from '../../Components/Shared/LoadingSpinner';
import { MembershipProductService } from '../../Services/MembershipProductService';

const AdminUsers = () => {
  const [memberResult, setMemberResult] = useState({} as WebApiServicesDataTransferObjectsGroupServiceGroupResultDto);
  const [memberFieldSettings, setMemberFieldSettings] = useState([] as WebApiModelsMemberField[]);
  const [membershipProducts, setMembershipProducts] = useState([] as WebApiModelsMembershipProduct[]);
  const [hasPingPaymentIntegration, setHasPingPaymentIntegration] = useState(false as boolean);
  const [user, setUser] = useState({} as AuthenticatedUser);
  const [loading, setLoading] = useState(true);

  const GetText = TextService.GetText;

  // Single useEffect to fetch all data - eliminates duplicate API calls
  useEffect(() => {
    const fetchAll = async () => {
      try {
        setLoading(true);
        const [user, members, fields, integrations, membershipProducts] = await Promise.all([
          AuthProvider().GetLoggedInUser(),
          MemberService.GetAllMembers(),
          MemberFieldService.GetMemberFields(),
          IntegrationService.GetActiveIntegrations(),
          MembershipProductService.GetAllMembershipProducts()
        ]);

        setUser(user!);
        setMemberResult(members);
        setMemberFieldSettings(fields);
        setMembershipProducts(membershipProducts);
        const pingPayments = integrations.find((p: any) => p.type == IntegrationType.PingPayments);
        setHasPingPaymentIntegration(!!pingPayments);
      } catch (error) {
        console.error('Error fetching data:', error);
      } finally {
        setLoading(false);
      }
    };
    fetchAll();
  }, []);

  // Super simple: just check if we have the basic data we need
  const hasData = memberResult.members != null;

  // Memoize the loadMembers function to prevent unnecessary re-creations
  const loadMembers = useCallback(async () => {
    try {
      setLoading(true);
      // Only reload members and fields, not user/integrations
      const [members, fields] = await Promise.all([
        MemberService.GetAllMembers(),
        MemberFieldService.GetMemberFields()
      ]);
      setMemberResult(members);
      setMemberFieldSettings(fields);
    } catch (error) {
      console.error('Error reloading members:', error);
    } finally {
      setLoading(false);
    }
  }, []);

  return <LayoutLeftMenu title={GetText("Users_UsersTitle")} menu={<LeftMenu selected={"users"}></LeftMenu>}>
    {hasData ? (
      <MemberList
        user={user}
        memberResult={memberResult}
        hasPingPaymentIntegration={hasPingPaymentIntegration}
        membershipProducts={membershipProducts}
        loadMembers={loadMembers}
        memberFieldSettings={memberFieldSettings}
      />
    ) : (
      <LoadingSpinner loadingText="Laddar medlemmar..." />
    )}
  </LayoutLeftMenu>
};

export default AdminUsers;